import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const ErrorMessage = (props) => {

    let message = 'Er ging iets fout.'

    if (props.type === 'no-results') {
        message = 'Geen resultaten gevonden.'
    } else if (props.type === 'filter-error') {
        message = 'Het filter kon niet geladen worden.'
    } else if (props.type === 'posts-error') {
        message = 'Er ging iets fout. Probeer de pagina te herladen.'
    }

    return (
        <div className="c-projects__error">
            <p>{message}</p>
        </div>
    )

}

export default ErrorMessage

// WEBPACK FOOTER //
// ./src/js/projects/components/ErrorMessage.js
